import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Box, InfoOutlineIcon,Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

import { ListItem } from '../ManyItemsTooltip/CategorizedHint';

const MOUSE_SENSITIVITY = 3;

const Wrapper = styled(Box)<{ wrapperHeigh: number, space: string, leftMode: number }>`
  position: fixed;
  z-index: 2000;
  margin-left: ${({ space, leftMode }) => leftMode ? `-${leftMode + 10}px` : space};
  margin-top: ${({ wrapperHeigh }) => -wrapperHeigh/2}px;
  display: flex;

  &:before {
    content: '';
    position: absolute;
    ${({ leftMode }) => leftMode ? 'right: -5px' : 'left: -5px'};
    background: ${({ theme }) => theme.colors.background3};
    width: 20px;
    height: 20px;
    justify-content: center;
    border-radius: 4px;
    transform: rotate(45deg);
  }
`;

interface Props {
  children?: React.ReactNode;
  width?: string;
  hasIcon?: boolean;
  items?: string[];
  hint?: React.ReactNode;
  space?: string;
}

const Tip: React.FC<Props> = ({
  width = '250px',
  space = '28px',
  hasIcon,
  children,
  items,
  hint,
}) => {
  const [leftMode, setLeftMode] = useState(0);
  const [positionY, setPositionY] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const reset = useMemo(() => () => setPositionY(0), [setPositionY]);
  const move = useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const widthValue = Number(width.replace('px', ''));
    if (window.screen.width - event.clientX < widthValue && !leftMode) {
      setLeftMode(widthValue);
    }
    if (Math.abs(positionY - event.clientY) >= MOUSE_SENSITIVITY) {
      setPositionY(event.clientY);
    }
  }, [width, leftMode, setLeftMode, setPositionY, positionY]);

  return (
    <Box style={{ position: 'relative' }}>
      <Box {...hint ? { onMouseLeave: reset } : {}}>
        <Box
          {...hint ? {} : { onMouseLeave: reset }}
          onMouseEnter={(event) => setPositionY(event.clientY)}
          onMouseMove={move}
        >
          {hasIcon ? <InfoOutlineIcon color="#C4C4C4" size="16px" height="16px" /> : null}
          {children}
        </Box>
        <Wrapper
          ref={ref}
          wrapperHeigh={ref?.current?.offsetHeight || 0}
          leftMode={leftMode}
          width={{ min: width }}
          space={space}
          background="background3"
          pad="spacing12"
          round="small"
          color="textOnColor"
          justify="center"
          {...positionY ? { style: { opacity: 1, top: `${positionY}px` }} : { style: { opacity: 0, zIndex: -1 }}}
        >
          {items?.length && !hint ? (
            <Box>
              {items.map((item) => (
                <ListItem
                  key={item}
                  pad={{ left: 'spacing16' }}
                >
                  <Inscription
                    size="12px"
                    color="textOnColor"
                  >
                    {item}
                  </Inscription>
                </ListItem>
              ))}
            </Box>
          ) : null}

          {hint}
        </Wrapper>
      </Box>
    </Box>
  );
};

export default Tip;
